import {
  ILanguageInstance,
  profileActions,
  tCreateStudentTargetLanguage
} from 'common/modules/ReactShared';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from 'students/stores/_utils';
import { userSelectors } from 'students/stores/user';
import { useSelect } from '../LanguagesPopup';
import { getTypedLevel } from './getTypedLevel';

interface IReturnObject {
  languages: ILanguageInstance[];
  pickedLanIds: string[];
  pickedLevel: string;
  pickLang: (id: string | number) => void;
  pickLevel: (id: string | number) => void;
  onResetLevel: () => void;
  onReset: () => void;
  targetLangLevelEditSubmit: (langInstanceId: number) => () => void;
  sortedAllLangs: ILanguageInstance[];
  handleSubmit: () => void;
}

export const useTargetLangPopup = (): IReturnObject => {
  const dispatch = useDispatch();

  const languages = useTypedSelector(userSelectors.selectSortedTargetLangs);
  const sortedAllLangs = useTypedSelector(userSelectors.selectSortedAllLangs);
  const currentTargetLanguage = useTypedSelector(
    userSelectors.selectProfileCurrentTargetLanguage
  );
  // Preselect the student's active target language; fall back to the first
  // available language only when the student has none yet.
  const fallbackPickedIds = languages[0] ? [`${languages[0].id}`] : [];
  const defaultPickedIds = currentTargetLanguage
    ? [`${currentTargetLanguage.languageId}`]
    : fallbackPickedIds;
  const {
    pick: pickLang,
    onReset,
    pickedIds: pickedLanIds
  } = useSelect({
    defaultPickedIds,
    multiple: false
  });
  const {
    pick: pickLevel,
    onReset: onResetLevel,
    pickedIds: [pickedLevel]
  } = useSelect({
    multiple: false
  });
  const handleSubmit = useCallback(() => {
    const userLanguage: tCreateStudentTargetLanguage = {
      active: true,
      languageId: +pickedLanIds[0],
      level: getTypedLevel(pickedLevel)
    };
    dispatch(profileActions.selectStudentTargetLanguage(userLanguage));
  }, [dispatch, pickedLanIds, pickedLevel]);

  const targetLangLevelEditSubmit = useCallback(
    (languageInstanceId: number) => () => {
      const userLanguage = {
        active: true,
        languageId: languageInstanceId,
        level: getTypedLevel(pickedLevel)
      };
      dispatch(profileActions.selectStudentTargetLanguage(userLanguage));
    },
    [dispatch, pickedLevel]
  );

  return {
    languages,
    pickedLanIds,
    pickedLevel,
    pickLang,
    pickLevel,
    onResetLevel,
    onReset,
    targetLangLevelEditSubmit,
    sortedAllLangs,
    handleSubmit
  };
};
